import { combineReducers } from 'redux';
import create from './create';
import edit from './edit';
import view from './view';
import orders from './orders';
import ROItem from './ro-item';
import ROPicklist from './ro-picklist';

export default combineReducers({
  create,
  edit,
  view,
  orders,
  ROItem,
  ROPicklist
});
